<template>
  <v-app>

    <v-main>
      <v-btn @click="enablereader">Enable/Disable Reader</v-btn>
      <div v-if="readerOn">
        <checkin @CodeRead="processCode"/>
      </div>
      <v-card v-if="information.Id != null">
        <p>Member ID: {{ information.Id }}</p>
        <p>Member: {{ information.FirstName }} {{ information.LastName }}</p>
        <p>Membership Level: {{ information.MembershipLevel.Name }}</p>
        <p>Family Members: </p>
          <ul>
            <li v-for="(member,index) in familyMembers" :key="index">{{ member }}</li>
          </ul>
        <p>_________________________</p>
        <p>Years as Member: {{ yearsAsMember }}</p>
        <p>Email: {{ email }}</p>
        <p>Phone: {{ phone }}</p>
        <p>Address: {{ address }}</p>
      </v-card>
    </v-main>
  </v-app>
</template>

<script>

//import send from './components/send';
import checkin from './components/checkin';

export default {
  name: 'App',

  components: {
    checkin
  },

  data: () => ({
    readerOn:false,//
    information: [],
    familyMembers:[],
    yearsAsMember:0,
    email:'',
    phone:'',
    address:''
  }),
  methods:{
    enablereader(){
      
      this.readerOn = !this.readerOn;
      if (this.readerOn) console.log('looking for QR code');
    },
    async processCode(code){

      //let api_key = 'Rwd2LrzGRs5pZiq8mFp6t7fVHXNUoTNJ89TcB2S6';
      
      let lookupURL = 'https://syvcflbe35.execute-api.us-east-1.amazonaws.com/v1/getuser'
    
      let payload = {
        'method':'POST',
        'body':JSON.stringify({
          'code':code
        }),
        'headers':{
          'Content-Type': 'application/x-www-form-urlencoded'
      }}
      
      this.information = await fetch(lookupURL,payload).then(response => {
        if (!response.ok) {
            throw new Error(response.error)
        }
        return response.json();
      }).catch(function(error) {
        console.log(error)
      });

      await this.populateAdditional();

      //console.log(this.information)
      this.readerOn = false;

    },
    findYears(dateStr){
      const currentDate = new Date();  // Get the current date
      const targetDate = new Date(dateStr);  // Parse the target date string

      // Calculate the difference in milliseconds between the two dates
      const differenceInMilliseconds = currentDate - targetDate;

      // Calculate the number of milliseconds in a year
      const millisecondsInYear = 1000 * 60 * 60 * 24 * 365.25;

      // Calculate the number of years by dividing the difference by milliseconds in a year
      const yearsDifference = differenceInMilliseconds / millisecondsInYear;

      // Return the number of years rounded down to the nearest whole number
      return Math.floor(yearsDifference)+1 + ' (' + targetDate.getFullYear() + ')';
    },
    async populateAdditional(){
      this.familyMembers = this.information.FieldValues[24].Value.replace( /\n/g, "," ).split(",")
      this.familyMembers.push('Baby Sitter: ' + this.information.FieldValues[51].Value)
      this.yearsAsMember = this.findYears(this.information.FieldValues[35].Value)
      this.email = this.information.FieldValues[25].Value
      this.phone = this.information.FieldValues[27].Value
      this.address = this.information.FieldValues[28].Value
    }
  }
};
</script>
